export const DEFAULT_PAGE_NAME = 'Page'
export const DEFAULT_SECTION_NAME = 'Section'
